//events
var EVT_INTERACTION = new AnalyticsEvent("interaction-event", "aaEventInteraction");

//state variables
var totalEvents = 1; //start with page view event

$(document).ready(function () {
    if (/\/(movie\/|film\/|videos\/|showtimedetails).*/gi.test(window.location.pathname)) {
        adobeDataLayer.trackProductView();
    } else {
        adobeDataLayer.trackPageView();
    }
});

//generic interaction event handler
$(document).on('click', 'a, button', function (e) {
    try {
        //check if the event was handled elsewhere
        if (totalEvents == digitalData.events.length ||
            //the previously handled event might not have been an interaction
            digitalData.event.callString !== EVT_INTERACTION.callString) {
            console.log('tracking generic event', e);
            pushInteraction(e);
        }
        totalEvents = digitalData.events.length;
    } catch (error) {
        console.log("Data layer error: " + error);
    }
});

function AnalyticsEvent(name, callString) {
    this.name = name;
    this.callString = callString;
}

function getNewInteractionEvent() {
    return new AnalyticsEvent(EVT_INTERACTION.name, EVT_INTERACTION.callString);
}

function pushInteraction(e, eventType) {
    eventType = eventType || getNewInteractionEvent();
    adobeDataLayer.trackEvent({
        name: eventType.name,
        callString: eventType.callString,
        interactionName: e ? formatEventWithCategory(e) : null,
        interactionType: e ? e.type : null
    });
}

function trackClickEvent(region, event) {
    var interaction = getNewInteractionEvent();
    interaction.interactionName = region + ' | ' + formatEventWithCategory(event);
    interaction.interactionType = 'click';
    adobeDataLayer.trackEvent(interaction);
}

function trackCustomClickEvent(targetText) {
    var interaction = getNewInteractionEvent();
    interaction.interactionName = targetText;
    interaction.interactionType = 'click';
    adobeDataLayer.trackEvent(interaction);
}

function formatEventWithCategory(e) {
    var target = e.target;
    var targetName = ($(target).text().trim()
        || $(target).attr('aria-label')
        || $(target).attr('alt')
        || $(target).attr('title')
        || target.innerText
        || $(target).attr('uib-popover')
        || target.href);

    targetName = targetName.toLowerCase().replace(/( |\s+)/gm, '_');

    return targetName;
}